import React, { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg';
import { codeReset } from '../../Api';

function Reset() { 
  const [formData, setFormData] = useState({
    email: '',
  });
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const navigate = useNavigate(); // Initialize the navigate function

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    try {
      // Pass the formData object to the resetPassword function
      const data = await codeReset(formData);
      // Redirect to the forgot-password-validate page with success message
      sessionStorage.setItem('canAccessValidate', 'true');
      navigate('/forgot-password-validate', {
        state: {
          message: data.message,
          email: formData.email,
        },
      });
    } catch (err) {
      // If error response exists, handle it
      if (err.response && err.response.data && err.response.data.message) {
        const backendError =
          err.response.data.message || 'Terjadi kesalahan, coba lagi';
        setError(backendError);
      } else {
        setError('Terjadi kesalahan, coba lagi');
      }
    }
  };

  return (
    <div className="login-page">
      <img src={Logo} alt="Jasa Indonesia Perdana Logo" className="logo" />
      <p>Reset password</p>
      <form className="login-form" onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter Your Email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <button type="submit">Continue</button>
      </form>

      {successMessage && <p className="success">{successMessage}</p>}
      {error && <p className="error">{error}</p>}

      <div className="links">
      <a href="/login"><span>Back to Login</span></a>
      </div>
    </div>
    
  );
}

export default Reset;
